import { selectWeblabList } from 'src/redux/slices/weblab';
import { useAppSelector } from 'src/redux/hooks';
import WeblabId from 'src/weblab/weblabId';
import { checkWeblab } from 'src/utils';

export default function useCheckWeblab(weblabId: WeblabId): boolean {
  const weblabList = useAppSelector(selectWeblabList);
  return checkWeblab(weblabId, weblabList);
}
